export default __webpack_public_path__ + "static/media/promotions-banner-v1.bb9d3202.png";